// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonAudit = {
  createdBy: "创建人",
  createdAt: "创建时间",
  updatedBy: "修改人",
  updatedAt: "修改时间",
} as const;
